<template>
  <div>
    <i
      v-if="assessment == 2"
      class="fa-wrapper fa fa-check-circle large-icon success"
    ></i>
    <i
      v-if="assessment == 1"
      class="fa-wrapper fa fa-dot-circle large-icon partial"
    ></i>
    <i
      v-if="assessment == -1"
      class="fa-wrapper fa fa-times-circle large-icon error"
    ></i>
  </div>
</template>
<style></style>
<script>
export default {
  name: "answer-icon",
  props: {
    assessment: Number
  }
};
</script>
